import { OPENING_HOURS, bakery, siteConfig } from '@/constants/site'

// schema.org names days in English, whatever language the site shows them in. Sunday is 0.
const SCHEMA_DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

// Search engines read this to show the bakery's address, phone and hours.
export const bakeryStructuredData = (): string => JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Bakery',
    name: siteConfig.name,
    description: siteConfig.description,
    image: siteConfig.ogImage,
    telephone: bakery.phoneHref.replace('tel:', ''),
    email: bakery.email,
    priceRange: '$',
    servesCuisine: 'Bakery',
    inLanguage: 'fa',
    sameAs: [bakery.instagram.url],
    address: {
        '@type': 'PostalAddress',
        streetAddress: bakery.street,
        addressLocality: bakery.locality,
        addressRegion: bakery.region,
        postalCode: bakery.postalCode,
        addressCountry: 'US'
    },
    openingHoursSpecification: OPENING_HOURS.filter(day => day.open && day.close).map(day => ({
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: `https://schema.org/${SCHEMA_DAYS[day.day]}`,
        opens: day.open,
        closes: day.close
    }))
}).replace(/</g, '\\u003c')
